/*
---------------------------------
Module - matrix-forms
---------------------------------
*/

import {simpleFormValidation} from "../../forms/js/global";


(function () {

    const matrixForms = (function () {
        
        let elMatrixForm;
        let elSubmitButton;
        let isSubmitting = false; // Flag to keep track when form is submitting. Prevent multiple submits

        function setupSubmitHandler() {

            // Intercept the submit event
            elSubmitButton.addEventListener('click', (event) => {
                
                event.preventDefault();

                if (!isSubmitting && simpleFormValidation(elMatrixForm)) {

                    isSubmitting = true;

                    // JS Submit won't include the submit button value so need to add it manually
                    const submit_input = document.createElement('input');
                    submit_input.type = 'hidden';
                    submit_input.name = elSubmitButton.name;
                    submit_input.value = elSubmitButton.value;
                            
                    elMatrixForm.appendChild(submit_input);

                    // For matrix custom forms - not account manager forms or password reset forms
                    if (elMatrixForm.id.includes("form_email_")) {

                        // Asynchronous function to generate the reCaptcha v3 token.
                        // Once token is generated, create a hidden input field and insert the value into the form
                        // Then JS submit
                        grecaptcha.ready(function() {
                            
                            grecaptcha.execute('6LdHLuQeAAAAAMSVylRLcjAcf2m_rgucM5E2gEaW', {action: 'submit'}).then(function(token) {
                            
                                const recaptcha_response_input = document.createElement('input');
                                recaptcha_response_input.type = 'hidden';
                                recaptcha_response_input.name = "g-recaptcha-response";
                                recaptcha_response_input.value = token;
                                
                                elMatrixForm.appendChild(recaptcha_response_input);
                                
                                elMatrixForm.submit();
                                
                            });
                            
                        });

                    } else {

                        elMatrixForm.submit();

                    }
                    
                }
                
            });
            
        }

        function init(element) {

            try {

                elMatrixForm = element;
                elSubmitButton = elMatrixForm.querySelector('[type="submit"]');

                setupSubmitHandler();

            } catch (error) {
                console.error(error);
            }

        }

        return {
            init
        };

    });

    document.addEventListener("DOMContentLoaded", function () {

        // Targets the following
        // - Matrix custom forms
        // - Account manager login, create and edit forms
        // - Password reset form
        let elMatrixForms = document.querySelectorAll("main form[id^=form_email_], main form[id^=page_account_manager_], main form[id^=page_password_reset_], main form[id=main_form]");

        if (elMatrixForms.length) {
            
            elMatrixForms.forEach((element) => {
                
                // Instantiate the object instance
                let matrixFormInstance = matrixForms();

                matrixFormInstance.init(element);

            });

        }

    });

})();
